module.exports = __webpack_public_path__ + "static/media/Expert.0f0b4120.svg";